import styled from 'styled-components';

export const FieldRequiredLabel = styled.span`
  :after {
    content: '*';
  }
`;

export default FieldRequiredLabel;
